// extracted by mini-css-extract-plugin
module.exports = {"primary":"#db4435","secondary":"#daaaaa"};